import { openRiskExplanation } from "@/features/portfolio-analysis/lib/risk-explanation-store";
import { cardChoice } from "@/features/intelligence/lib/card-choice";
import type { HandlerOutcome } from "@/features/intelligence/lib/frontend-tool-run";
import type { PrepareRiskExplanationArgs } from "@/features/intelligence/lib/frontend-tools";
import {
  choiceResult,
  searchedInstead,
  shownResult,
} from "@/features/intelligence/lib/tool-result";

export async function prepareRiskExplanation(
  { seed, ignored, notAnId }: PrepareRiskExplanationArgs,
  toolCallId: string,
): Promise<HandlerOutcome> {
  openRiskExplanation(toolCallId, seed);
  const choice = await cardChoice(seed, true, toolCallId);
  if (choice.kind === "chosen") {
    return shownResult(
      searchedInstead(`A risk card is shown in the chat. It ${READS}. ${UNSEEN}`, seed, notAnId),
      `points to the card; ${KEEP_OUT}`,
      ignored,
    );
  }
  return choiceResult(
    choice,
    searchedInstead(
      `A risk card is in the chat. Once the client and the portfolio are chosen, it ${READS}. ` +
        UNSEEN,
      seed,
      notAnId,
    ),
    KEEP_OUT,
    ignored,
    "the client or the portfolio",
  );
}

const READS =
  "reads the portfolio's expected return, volatility and CVaR from Quant itself and explains " +
  "them in fixed sentences";

const UNSEEN = "None of the figures reach you, and the card writes nothing";

const KEEP_OUT =
  "do not state, estimate or explain any risk figure yourself, do not compare it with the " +
  "client's risk profile, and do not call get_portfolio, get_portfolio_overview or " +
  "analyze_portfolio for it";
